import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFileAlt from '@fortawesome/fontawesome-free-regular/faFileAlt';
import styles from './article-list.module.scss';

const ArticleListItem = ({article}) => (
  <a
    className={classNames(
      styles.ArticleListItem,
      'is-size-5',
      'has-text-grey-darker'
    )}
    href={`/article/${article.number}-${article.slug}`}
  >
    <FontAwesomeIcon
      className={styles.ArticleListItem__icon}
      icon={faFileAlt}
    />
    {article.name}
  </a>
);

ArticleListItem.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export default ArticleListItem;



// WEBPACK FOOTER //
// ./src/components/articles/ArticleListItem.js